import axios from '@/http/axios/index.js'


export default {
    getBankAccounts(payload) {
        return axios.get('hsbc/bank-accounts', { params: payload }).then(res => res.data);
    },
    getReports(payload) {
        return axios.get('hsbc/reports', { params: payload }).then(res => res.data);
    },
    getTransaction(payload) {
        return axios.get('hsbc/report/get-transaction', { params: payload }).then(res => res.data);
    },
    getReportTransactions(payload) {
        return axios.get('hsbc/report/transactions', { params: payload }).then(res => res.data);
    },
    getVendors(payload){
        return axios.get('vendors/search', { params: payload }).then(res => res.data);
    },
    getExpenses(payload){
        return axios.get('hsbc/report/get-expenses', { params: payload }).then(res => res.data);
    },
    getLinkTypes(){
        return axios.get('hsbc/link/get-types').then(res => res.data);
    },
    linkExpenses(payload){
        return axios.post('hsbc/report/transaction/link-expenses',payload).then(res => res.data);
    }
    
}

